// Cloudflare Turnstile site key (public — safe to expose in frontend).
// Hardcoded here so the contributor sign-in flow never depends on a
// build-time env var being injected correctly into the bundle.
export const TURNSTILE_SITE_KEY = "0x4AAAAAACNuYd5UJ4IdGNvh";
